import {IModelServiceDefinitionApiResponse, RestQueryParams} from 'educat-common-web';
import {Observable} from 'rxjs';
import {educatAPI} from "educat-common-web";


export function getSubjectTestsAPI(
    authToken: string | null
): Observable<typeof IModelServiceDefinitionApiResponse> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }
    return educatAPI.get(
        `service_definitions?serviceSubjectTest[null]=false`,
        new RestQueryParams(),
        headers
    );
}
